var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"page-container",attrs:{"id":"sme-signup"}})
}
var staticRenderFns = []

export { render, staticRenderFns }